import React, { useState, useEffect, useContext, useRef } from 'react';

import { cmnContext } from '../../../../common/CmnContext';
import { SaleListContext } from '../../SaleListContext';


export function SaleListSearchLabel(props: any) {

  const isPc = useContext(cmnContext).isPc;
  const {
    isLoading,
    searchLabel, searchTypeList, setSearchTypeList,
  } = useContext(SaleListContext);

  const labelKey = props.labelKey;
  const isCheck = props.isCheck;

  const [labelTxt, setLabelTxt] = useState<string>('');


  useEffect(() => {
    setLabelTxt(searchLabel[labelKey]);
  }, [labelKey])


  // ボタンタップ
  const onPress = () => {
    if(!isLoading) {
      let newSearchLabelList: any = Object.keys(searchLabel).reduce(
        (acc, key) => ({ ...acc, [key]: false }),
        {}
      );
      newSearchLabelList[labelKey] = !searchTypeList[labelKey];
      setSearchTypeList(newSearchLabelList);
    }
  }


  return (
    <>
    {labelTxt &&
      <div
        className='btn'
        style={{
          margin: isPc? '5px 5px 0px' : '5px 3px 0px',
          padding: isPc? '5px 10px': '5px',
          backgroundColor: isCheck? '#60a5fa' : '#f1f7fc',
        }}
        onClick={onPress}
      >
        <p style={{
          margin: 0,
          fontSize: isPc? '100%' : '85%',
          fontWeight: 'normal',
          color: isCheck? '#fff' : 'gray',
        }}>{labelTxt}</p>
      </div>
    }
    </>
  );
}